(() => {
  const sizeControl = root => [...root.querySelectorAll('select[data-option-name]')].find(el => /ring\s*size/i.test(el.dataset.optionName));
  const chartControl = (root, optionName) => {
    const name = (optionName || '').trim().toLowerCase();
    if (!name) return null;
    return [...root.querySelectorAll('select[data-option-name]')].find(el => (el.dataset.optionName || '').trim().toLowerCase() === name);
  };
  const sizePrompt = option => /not\s*sure|can[’']?t\s*find|need\s+assistance\s+finding/i.test(option.value + ' ' + option.textContent);
  const sortSizePrompt = (select, setDefault) => {
    if (!select) return false;
    const prompts = [...select.options].filter(sizePrompt);
    if (!prompts.length) return false;
    prompts.forEach(option => {
      if (option.textContent !== "I can't find my size") option.textContent = "I can't find my size";
      if (select.lastElementChild !== option) select.append(option);
    });
    if (setDefault && prompts.some(option => option.selected)) {
      const firstRealSize = [...select.options].find(option => option.value && !sizePrompt(option) && !option.disabled);
      if (firstRealSize) {
        select.value = firstRealSize.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    return true;
  };
  const reorderProductOptions = (root, setDefault) => {
    const picker = root.querySelector('kit-variant-picker.kit-product-variant-picker');
    if (!picker) return;
    const allFields = [...picker.querySelectorAll('fieldset.kit-fieldset')];
    const label = field => field.querySelector('.kit-fieldset__legend-text')?.textContent.trim().toLowerCase() || '';
    const productText = (picker.dataset.productTitle || '') + ' ' + (root.querySelector('[data-rx-description]')?.textContent || '');
    const isRubyProduct = /ruby/i.test(productText);
    const choiceText = field => {
      const inputs = [...field.querySelectorAll('input[type="radio"]')];
      return (field.textContent + ' ' + inputs.map(input => input.value).join(' ')).toLowerCase();
    };
    const classify = text => ({
      treatment: /(?:untreated|unreated)/i.test(text) ? 'untreated' : /\btreated\b/i.test(text) ? 'treated' : null,
      stone: /cubic zirconia/i.test(text) ? 'cubic zirconia' : /moissanite/i.test(text) ? 'moissanite' : null
    });
    const combinedRubyField = isRubyProduct && allFields.find(field => {
      if (field.hasAttribute('data-rx-ruby-combined') || field.hasAttribute('data-rx-split-field')) return false;
      const text = choiceText(field);
      return /untreated/i.test(text) && /\btreated\b/i.test(text) && /cubic zirconia/i.test(text) && /moissanite/i.test(text);
    });
    let treatmentField = picker.querySelector('fieldset[data-rx-split-field="treatment"]');
    let splitStoneField = picker.querySelector('fieldset[data-rx-split-field="stone"]');
    if (combinedRubyField && !treatmentField && !splitStoneField) {
      const sourceRadios = [...combinedRubyField.querySelectorAll('input[type="radio"]')];
      const choices = sourceRadios.map(input => {
        const sourceLabel = input.closest('label.kit-radio');
        const parsed = classify((input.value || '') + ' ' + (sourceLabel?.textContent || ''));
        return { input, sourceLabel, ...parsed };
      }).filter(choice => choice.sourceLabel && choice.treatment && choice.stone);
      const selectedSource = choices.find(choice => choice.input.checked) || choices[0];
      if (choices.length >= 4 && selectedSource) {
        const makeChoiceField = (kind, legendText, values, display) => {
          const field = combinedRubyField.cloneNode(false);
          field.dataset.rxSplitField = kind;
          const legendEl = combinedRubyField.querySelector('legend')?.cloneNode(true);
          if (legendEl) {
            const text = legendEl.querySelector('.kit-fieldset__legend-text');
            if (text) text.textContent = legendText;
            field.append(legendEl);
          }
          const sourceStack = choices[0].sourceLabel.parentElement;
          const stack = sourceStack.cloneNode(false);
          field.append(stack);
          values.forEach(value => {
            const representative = choices.find(choice => choice[kind] === value);
            const optionLabel = representative.sourceLabel.cloneNode(true);
            const input = optionLabel.querySelector('input[type="radio"]');
            const selectedValue = selectedSource[kind];
            input.name = 'roxari-ruby-' + kind + '-' + picker.dataset.productId;
            input.value = value;
            input.checked = selectedValue === value;
            input.removeAttribute('data-option-value-id');
            input.removeAttribute('data-option-name');
            input.removeAttribute('data-product-url');
            optionLabel.removeAttribute('data-option-value-id');
            optionLabel.removeAttribute('data-option-name');
            optionLabel.removeAttribute('data-product-url');
            optionLabel.dataset.rxRubyChoice = value;
            const button = optionLabel.querySelector('.kit-button');
            if (button) button.textContent = display(value);
            input.addEventListener('change', event => {
              event.stopPropagation();
              if (!input.checked) return;
              const treatment = kind === 'treatment'
                ? value
                : picker.querySelector('fieldset[data-rx-split-field="treatment"] input:checked')?.value;
              const stone = kind === 'stone'
                ? value
                : picker.querySelector('fieldset[data-rx-split-field="stone"] input:checked')?.value;
              const match = choices.find(choice => choice.treatment === treatment && choice.stone === stone);
              if (!match) return;
              sourceRadios.forEach(radio => { radio.checked = radio === match.input; });
              match.input.dispatchEvent(new Event('change', { bubbles: true }));
            });
            stack.append(optionLabel);
          });
          return field;
        };
        treatmentField = makeChoiceField('treatment', 'Ruby Treatment', ['treated', 'untreated'], value => value === 'treated' ? 'Treated Ruby' : 'Untreated Ruby');
        splitStoneField = makeChoiceField('stone', 'Stone Type', ['cubic zirconia', 'moissanite'], value => value === 'cubic zirconia' ? 'Cubic Zirconia' : 'Moissanite');
        combinedRubyField.dataset.rxRubyCombined = 'true';
        combinedRubyField.hidden = true;
        combinedRubyField.parentElement.insertBefore(treatmentField, combinedRubyField);
        combinedRubyField.parentElement.insertBefore(splitStoneField, combinedRubyField);
      }
    }
    const fields = allFields.filter(field => !field.hasAttribute('data-rx-ruby-combined') && !field.hasAttribute('data-rx-split-field'));
    treatmentField = treatmentField || fields.find(field => {
      const text = choiceText(field);
      return isRubyProduct && /untreated/i.test(text) && /\btreated\b/i.test(text);
    });
    const stoneField = splitStoneField || fields.find(field => /stone|gemstone/.test(label(field)) || (/cubic zirconia/i.test(choiceText(field)) && /moissanite/i.test(choiceText(field))));
    const sizeField = fields.find(field => /size|length/.test(label(field)));
    const orderedFields = [...new Set([treatmentField, stoneField, sizeField].filter(Boolean))];
    if (orderedFields.length && orderedFields.every(field => field.parentElement === orderedFields[0].parentElement)) {
      const container = orderedFields[0].parentElement;
      const currentFields = [...container.children].filter(field => field.matches('fieldset.kit-fieldset') && !field.hidden);
      const alreadyOrdered = orderedFields.every((field, index) => currentFields[index] === field);
      if (!alreadyOrdered) {
        const marker = document.createComment('roxari-product-option-order');
        container.insertBefore(marker, container.firstElementChild);
        orderedFields.forEach(field => container.insertBefore(field, marker));
        marker.remove();
      }
    } else if (stoneField?.parentElement) {
      const container = stoneField.parentElement;
      if (stoneField !== container.firstElementChild) container.insertBefore(stoneField, container.firstElementChild);
    }
    const sizeSelect = sizeField?.querySelector('select[data-option-name]');
    sortSizePrompt(sizeSelect, setDefault);
  };
  if (!customElements.get('roxari-product-extras')) customElements.define('roxari-product-extras', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.root = this.closest('.product-section');
      this.form = this.closest('form');
      if (!this.root || !this.form) return;
      const checkbox = this.querySelector('[data-rx-gift]');
      const wrap = this.querySelector('[data-rx-message-wrap]');
      const message = wrap.querySelector('textarea');
      checkbox.addEventListener('change', () => {
        wrap.hidden = !checkbox.checked;
        message.disabled = !checkbox.checked;
        if (!checkbox.checked) message.value = '';
      });
      const dialog = this.querySelector('dialog');
      if (dialog) {
        this.querySelector('[data-rx-open-size]').addEventListener('click', () => { dialog.showModal(); document.documentElement.classList.add('rx-modal-open'); });
        this.querySelector('[data-rx-close-size]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => document.documentElement.classList.remove('rx-modal-open'));
        dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
      }
      this.optionsInitialized = false;
      this.optionObserver = new MutationObserver(() => {
        if (this.optionFrame) return;
        this.optionFrame = requestAnimationFrame(() => {
          this.optionFrame = null;
          reorderProductOptions(this.root, false);
        });
      });
      this.optionObserver.observe(this.root, { childList: true, subtree: true });
      this.sync = () => {
        reorderProductOptions(this.root, !this.optionsInitialized && !new URLSearchParams(window.location.search).has('variant'));
        this.optionsInitialized = true;
        const select = sizeControl(this.root);
        const chartSelect = chartControl(this.root, this.dataset.sizeOption);
        const activeSizeSelect = select || chartSelect;
        const flag = this.querySelector('[data-rx-size-confirmation]');
        if (select) {
          sortSizePrompt(select, false);
          if (flag) flag.disabled = !sizePrompt(select.selectedOptions[0] || { value: '', textContent: '' });
        } else if (flag) flag.disabled = true;
        if (chartSelect) sortSizePrompt(chartSelect, false);
        if (activeSizeSelect) {
          const guide = this.querySelector('.rx-size-guide');
          const fieldset = activeSizeSelect.closest('fieldset');
          const legend = fieldset?.querySelector('legend');
          if (legend) {
            if (select) legend.textContent = this.dataset.sizeLabel;
            else if (/chain/i.test(chartSelect?.dataset.optionName || '')) legend.textContent = 'Choose Your Chain Length';
            else if (this.dataset.productUrl.includes('/products/iconic-dazzle-bracelet')) legend.textContent = 'Choose Your Bracelet Size';
            else legend.textContent = this.dataset.chartKind === 'bangle' ? 'Choose Your Bangle Size' : 'Choose Your Bracelet Length';
          }
          const selectWrap = activeSizeSelect.closest('.kit-select');
          if (guide && selectWrap) {
            let row = selectWrap.parentElement;
            if (!row.classList.contains('rx-size-row')) {
              row = document.createElement('div');
              row.className = 'rx-size-row';
              selectWrap.parentNode.insertBefore(row, selectWrap);
              row.append(selectWrap);
            }
            if (guide.parentElement !== row) row.append(guide);
          }
        }
        const link = this.root.querySelector('[data-rx-whatsapp]');
        if (!link) return;
        const lines = [this.dataset.helpMessage, '', 'Product: ' + this.dataset.productTitle];
        const selector = this.root.querySelector('roxari-ring-selector');
        if (selector) {
          const selections = [];
          for (const [group, label] of [['carat','Carat'],['shape','Shape'],['style','Style'],['prong','Prong']]) {
            const field = selector.querySelector('[data-group="' + group + '"]');
            const selected = field?.querySelector('[aria-pressed="true"]');
            if (field && !field.hidden && selected) selections.push(label + ': ' + selected.textContent.trim());
          }
          if (selections.length) lines.push('Design preview request:', ...selections);
        }
        if (select) lines.push('Ring Size: ' + select.selectedOptions[0].textContent.trim());
        else if (chartSelect) lines.push((/chain/i.test(chartSelect.dataset.optionName || '') ? 'Chain Length: ' : this.dataset.productUrl.includes('/products/iconic-dazzle-bracelet') ? 'Bracelet Size: ' : this.dataset.chartKind === 'bangle' ? 'Bangle Size: ' : 'Bracelet Length: ') + chartSelect.selectedOptions[0].textContent.trim());
        lines.push('Product Link: ' + this.dataset.productUrl);
        link.href = 'https://wa.me/923288333999?text=' + encodeURIComponent(lines.join('\n'));
      };
      this.onChange = () => this.sync();
      this.onClick = () => queueMicrotask(this.sync);
      this.root.addEventListener('change', this.onChange);
      this.root.addEventListener('click', this.onClick);
      this.form.addEventListener('submit', this.onChange, true);
      this.sync();
    }
    disconnectedCallback() {
      if (!this.root) return;
      this.root.removeEventListener('change', this.onChange);
      this.root.removeEventListener('click', this.onClick);
      this.form?.removeEventListener('submit', this.onChange, true);
      this.optionObserver?.disconnect();
      if (this.optionFrame) cancelAnimationFrame(this.optionFrame);
      document.documentElement.classList.remove('rx-modal-open');
      this.bound = false;
    }
  });
  if (!customElements.get('roxari-product-information')) customElements.define('roxari-product-information', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const content = this.querySelector('[data-rx-description]');
      const specs = this.querySelector('[data-rx-specifications]');
      const headings = [...content.querySelectorAll('h1,h2,h3,h4')];
      const specHeading = headings.find(h => /^(?:key\s+features|product\s+(?:details|specifications))\s*:?$/i.test(h.textContent.trim()));
      const list = specHeading?.nextElementSibling;
      if (list?.tagName === 'UL') {
        const featureItems = [...list.children].filter(item => /^(?:cent(?:er|re)\s+stone|metal|finish|certification)\s*:/i.test(item.textContent.trim()));
        if (featureItems.length) {
          const featureList = document.createElement('ul');
          featureItems.forEach(item => featureList.append(item));
          specs.append(featureList);
          specs.hidden = false;
          if (!list.children.length) {
            list.remove();
            specHeading.remove();
          }
        }
      }
      const faq = headings.find(h => /^faqs?\s*:/i.test(h.textContent.trim()));
      if (faq) {
        let node = faq;
        while(node) {
          const next = node.nextElementSibling;
          if (node !== faq && /^H[1-4]$/.test(node.tagName) && !/\?|^(can |do |does |what |is |are |how |why |when |where )/i.test(node.textContent.trim())) break;
          node.remove(); node = next;
        }
      }
    }
  });
  const alignReviewHeaders = () => {
    document.querySelectorAll('.product-single__meta .areviews_main_header_container').forEach(container => {
      const rating = container.querySelector('.header_reviews_number') || container.querySelector('.areviews_header_rating');
      if (!rating) return;
      const stars = [...rating.children].filter(el => el.matches('i.fa-star, i.fa-star-half-alt, i.fa-star-half'));
      if (!stars.length) return;
      const group = document.createElement('span');
      group.className = 'rx-review-stars';
      group.style.setProperty('display', 'flex', 'important');
      group.style.setProperty('justify-content', 'center', 'important');
      group.style.setProperty('gap', '4px', 'important');
      rating.insertBefore(group, stars[0]);
      stars.forEach(star => group.append(star));
      const label = document.createElement('span');
      label.className = 'rx-review-label';
      [...rating.childNodes].filter(node => node !== group && (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE && !node.matches('.areviewstooltiptext, style'))).forEach(node => label.append(node));
      label.style.setProperty('display', 'block', 'important');
      label.style.setProperty('color', '#f4f1eb', 'important');
      label.querySelectorAll('span, a').forEach(el => el.style.setProperty('color', '#f4f1eb', 'important'));
      rating.append(label);
      rating.style.setProperty('width', '100%', 'important');
      rating.style.setProperty('text-align', 'center', 'important');
    });
  };
  let reviewFrame;
  new MutationObserver(records => {
    if (!records.some(record => record.addedNodes.length)) return;
    if (reviewFrame) return;
    reviewFrame = requestAnimationFrame(() => { reviewFrame = null; alignReviewHeaders(); });
  }).observe(document.body, {childList: true, subtree: true});
  alignReviewHeaders();
  const enableImageTap = () => document.querySelectorAll('.rx-product [data-product-photos]').forEach(gallery => {
    if (gallery.dataset.rxTapReady) return;
    gallery.dataset.rxTapReady = 'true';
    let down;
    gallery.addEventListener('pointerdown', e => { down = {x:e.clientX,y:e.clientY}; }, {passive:true});
    gallery.addEventListener('click', e => {
      const image = e.target.closest('.photoswipe__image');
      if (!image || !down || Math.abs(e.clientX-down.x)>8 || Math.abs(e.clientY-down.y)>8) return;
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      const button = image.closest('.image-wrap')?.querySelector('.js-photoswipe__zoom');
      if (button) { e.stopImmediatePropagation(); button.click(); }
    }, true);
  });
  enableImageTap();
  document.addEventListener('shopify:section:load',enableImageTap);
})();
